import restClient from "../restClient";


export const getWorksheetDetail = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.get(`worksheets/${id}`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const createWorksheet = async (data) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await restClient.post(`worksheets`, { data: data }, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const updateWorksheet = async (id, data) => {
  try {


    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await restClient.put(`worksheets/${id}`, { data: data }, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const deleteWorksheet = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.delete(`worksheets/${id}`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    return null;
  }
};

export const printWorksheet = async (id, isWorksheet, documents, documentName) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: 'blob' // Expecting a PDF file
    };
    
    const payload = isWorksheet ? { worksheet_id: id } : { deal_id: id };
    if (documentName) {
      payload.document_name = documentName;
    } else {
      payload.documents = documents;
    }

    const response = await restClient.post(`worksheets/ecabinet-viewer`, payload, config);

    return response; // Return the whole response to access headers if needed
  } catch (err) {
    console.log(err);
    throw err;
  }
};
